import eurekaMgrs from '@eureka/ui-managers';
const eventBus = eurekaMgrs.eventBus;

const MessageToastFunc = (message, options) => {
  eventBus.emit('on-message-toast', '', {
    content: message || (options && options.message) || '',
    ...options,
  });
};

const DefaultDuration = 3000;

export const MessageToast = {
  success(message, options = null) {
    MessageToastFunc(message, {
      ...(options || {}),
      duration: DefaultDuration,
      type: 'success',
    });
  },
  error(message, options = null) {
    MessageToastFunc(message, {
      ...(options || {}),
      duration: DefaultDuration,
      type: 'error',
    });
  },
  warn(message, options = null) {
    MessageToastFunc(message, {
      ...(options || {}),
      duration: DefaultDuration,
      type: 'warn',
    });
  },
  warning(message, options = null) {
    MessageToastFunc(message, {
      ...(options || {}),
      duration: DefaultDuration,
      type: 'warning',
    });
  },
  info(message, options = null) {
    MessageToastFunc(message, {
      ...(options || {}),
      type: 'info',
      duration: DefaultDuration,
    });
  },
};
